import React from 'react';
import { createRoot } from 'react-dom/client';
import 'remixicon/fonts/remixicon.css';
import { logDeploymentInfo } from '@utils/logDeploymentInfo';
import {
  clearLoginState,
  clearStoredSession,
  isAuthPopupWindow,
} from '@utils/auth-relay';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Application from './App';
import logger from './app/services/logger';

logDeploymentInfo();

logger.debug(`SupportApplet: entrypoint ${window.location}`);

// Both must run before AuthProvider mounts, as it reads storage on first render
const urlParams = new URLSearchParams(window.location.search);
const isLoginCallback = urlParams.has('code') || urlParams.has('error');

// The sign-in popup always starts a fresh login rather than reusing (and
// handing back) whatever session its own storage still holds
if (isAuthPopupWindow() && !isLoginCallback) {
  clearStoredSession();
}

// A login can only be finishing in a window that Keycloak just sent back here.
// Anywhere else (including the Zendesk iframe, which never runs a login) the
// in-progress flag is left over from an interrupted attempt, and would make the
// library fail the page load with "Bad authorization state".
if (!isLoginCallback) {
  clearLoginState();
}

const root = createRoot(document.getElementById('root') as HTMLElement);
const strictMode = process.env.REACT_APP_STRICT_MODE === 'true';

if (strictMode) {
  root.render(
    <React.StrictMode>
      <Application />
    </React.StrictMode>
  );
} else {
  root.render(<Application />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
